/*
 * @providesModule ForgotPasswordStyle
 */

import { StyleSheet, Dimensions } from 'react-native';
import Sizes from 'Sizes';

export const MODAL_HEIGHT = Sizes.isTablet() ? 407 : 358;
export const MODAL_ERROR_HEIGHT = Sizes.isTablet() ? 421 : 372;

const overlayHeight = Dimensions.get('screen').height;
const HEADER_FONT_SIZE = Sizes.isTablet() ? 24 : 20;
const VIEW_FONT_SIZE = Sizes.isTablet() ? 19 : 16;
const LABEL_FONT_SIZE = Sizes.isTablet() ? 14 : 12;
const HORIZONTAL_MARGINS = Sizes.isTablet() ? 230 : 32;

export default StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },

  containerOverlay: {
    width: '100%',
    height: overlayHeight,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },

  inputError: {
    marginTop: 16,
    height: Sizes.isTablet() ? 75 : 62,
    marginHorizontal: HORIZONTAL_MARGINS,
    borderColor: 'rgba(221, 105, 82, 1)',
    borderWidth: 2,
    borderRadius: 9,
    flexDirection: 'row',
  },

  headerText: {
    height: Sizes.isTablet() ? 31 : 28,
    fontSize: HEADER_FONT_SIZE,
    fontFamily: 'OpenSans-Bold',
    color: '#000000',
    marginTop: 24,
    marginHorizontal: Sizes.isTablet() ? 230 : 34,
  },

  messageText: {
    fontSize: VIEW_FONT_SIZE,
    height: Sizes.isTablet() ? 56 : 48,
    fontFamily: 'OpenSans-Regular',
    marginTop: 20,
    marginHorizontal: HORIZONTAL_MARGINS,
    color: '#000000',
  },

  inputHighlight: {
    marginTop: 16,
    height: Sizes.isTablet() ? 75 : 62,
    marginHorizontal: HORIZONTAL_MARGINS,
    borderColor: '#4890E8',
    borderWidth: 2,
    borderRadius: 9,
    flexDirection: 'row',
  },

  inputView: {
    marginTop: 16,
    marginHorizontal: HORIZONTAL_MARGINS,
    height: Sizes.isTablet() ? 75 : 62,
    borderColor: 'rgba(0, 0, 0, 0.4)',
    borderWidth: 1,
    borderRadius: 9,
    flexDirection: 'row',
  },

  textInput: {
    width: '80%',
    height: '100%',
  },

  textInInput: {
    left: 12,
    fontSize: VIEW_FONT_SIZE,
    fontFamily: 'OpenSans-Regular',
  },

  placeHolderText: {
    left: 12,
    color: '#757575',
    fontSize: VIEW_FONT_SIZE,
    fontFamily: 'OpenSans-SemiBold',
  },

  labelTextHighlight: {
    color: 'rgba(72, 144, 232, 1)',
    fontFamily: 'OpenSans-SemiBold',
    fontSize: LABEL_FONT_SIZE,
    left: 12,
  },

  errorContainer: {
    flexDirection: 'row',
    marginHorizontal: HORIZONTAL_MARGINS,
    marginTop: 4,
  },

  errorIcon: {
    height: 16,
    width: 16,
  },

  errorMessage: {
    fontSize: LABEL_FONT_SIZE,
    color: 'rgba(221, 105, 82, 1)',
    fontFamily: 'OpenSans-SemiBold',
    marginLeft: 5.33,
  },

  labelTextError: {
    fontFamily: 'OpenSans-SemiBold',
    color: 'rgba(221, 105, 82, 1)',
    fontSize: LABEL_FONT_SIZE,
    left: 12,
  },

  labelText: {
    fontFamily: 'OpenSans-SemiBold',
    color: '#757575',
    fontSize: LABEL_FONT_SIZE,
    left: 12,
  },

  loginText: {
    fontSize: Sizes.isTablet() ? 21 : 18,
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: '#ffffff',
  },

  submitButton: {
    marginHorizontal: HORIZONTAL_MARGINS,
    borderRadius: Sizes.isTablet() ? 29 : 24,
    height: Sizes.isTablet() ? 58 : 50,
    marginTop: Sizes.isTablet() ? 38 : 32,
    justifyContent: 'center',
    backgroundColor: '#4890E8',
  },

  cancelButton: {
    alignSelf: 'center',
    height: 24,
    marginTop: 20,
  },

  cancelText: {
    fontSize: Sizes.isTablet() ? 21 : 18,
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: 'rgba(0, 0, 0, 0.9)',
  },
});
